import { render } from "./template.vue?vue&type=template&id=b9ce6a28&scoped=true"
const script = {}

import "./template.vue?vue&type=style&index=0&id=b9ce6a28&lang=scss&scoped=true"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9ce6a28"]])

export default __exports__